import { render, staticRenderFns } from "./UploadCsvSuccessRecord.vue?vue&type=template&id=64df8fb8&scoped=true"
import script from "./UploadCsvSuccessRecord.ts?vue&type=script&lang=ts&external"
export * from "./UploadCsvSuccessRecord.ts?vue&type=script&lang=ts&external"
import style0 from "./UploadCsvSuccessRecord.scss?vue&type=style&index=0&id=64df8fb8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df8fb8",
  null
  
)

export default component.exports